const colors = {
  // Primary colors
  primary: {
    main: '#4A7B63',     // Deep sage green (cup circle background)
    light: '#9AB5A7',    // Lighter sage
    dark: '#345847',     // Darker sage
  },
  
  // Secondary/Background colors
  background: {
    main: '#E8EDE7',     // Light sage background
    paper: '#FFFFFF',    // Pure white for cards/modals
    overlay: 'rgba(74, 123, 99, 0.1)', // Transparent sage for overlays
  },
  
  // Text colors
  text: {
    primary: '#2C3E35',    // Dark sage for primary text
    secondary: '#5F7268',  // Medium sage for secondary text
    disabled: '#A8B8B0',   // Light sage for disabled text
    white: '#FFFFFF',
  },
  
  // UI elements
  border: '#D2DCD6',      // Light sage for borders
  divider: '#E0E8E4',     // Very light sage for dividers
  
  // Status colors (maintaining the green theme)
  status: {
    success: '#4A7B63',   // Same as primary for consistency
    error: '#D32F2F',     // Keeping red for errors
    warning: '#F9A825',   // Keeping amber for warnings
    info: '#9AB5A7',      // Light sage for info
  }
};

export default colors; 